let id = 0;

export function genStrId() {
  id++;
  return id.toString();
}
